import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

export const PaymentMetaInfo = ({ transactionId, bankReferenceId, paymentMethod, isMobile }) => {
  const capitalizePaymentMethod = (method) => {
    if (!method) return '';
    return method.charAt(0).toUpperCase() + method.slice(1).toLowerCase();
  };

  return (
    <div className="rounded-lg border border-emerald-100 bg-emerald-50/60 p-2 text-xs text-emerald-800 dark:border-emerald-500/30 dark:bg-emerald-900/20 dark:text-emerald-100 sm:p-3 sm:text-sm">
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-wide text-emerald-600 dark:text-emerald-200 sm:text-xs">
        <CheckCircleIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
        Settled Payment Details
      </div>
      <div className="mt-2 grid gap-2 sm:grid-cols-2 sm:gap-3">
        {transactionId && (
          <div className="flex flex-col gap-0.5">
            <span className="text-xs font-medium text-emerald-700 dark:text-emerald-200">
              Transaction ID
            </span>
            <span className="truncate text-xs font-semibold text-emerald-900 dark:text-emerald-100 sm:text-sm">
              {transactionId}
            </span>
          </div>
        )}
        {bankReferenceId && (
          <div className="flex flex-col gap-0.5">
            <span className="text-xs font-medium text-emerald-700 dark:text-emerald-200">
              Bank Reference ID
            </span>
            <span className="truncate text-xs font-semibold text-emerald-900 dark:text-emerald-100 sm:text-sm">
              {bankReferenceId}
            </span>
          </div>
        )}
        {paymentMethod && (
          <div className="flex flex-col gap-0.5">
            <span className="text-xs font-medium text-emerald-700 dark:text-emerald-200">
              Payment method
            </span>
            <span className="truncate text-xs font-semibold text-emerald-900 dark:text-emerald-100 sm:text-sm">
              {capitalizePaymentMethod(paymentMethod)}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
